import { AxiosRequestConfig } from 'axios';
import { EmeraldRequestParams } from '../../common/interfaces/requests/EmeraldRequestParams';
import { emeraldRequest } from '../../common/api/emerald-request';
import { CommandMenuType, IPosUiMenu } from '../../common/interfaces/states/IPosUiMenuState';

export const getMenuConfig = async (menuType: CommandMenuType): Promise<IPosUiMenu> => {
  const axiosConfig: AxiosRequestConfig = {
    method: 'GET',
    url: `/menu/${menuType.toString().toLowerCase()}-menu-configuration`,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: false,
    showLoggingInfo: true,
  };

  return emeraldRequest<IPosUiMenu>(emeraldRequestParams);
};
